/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dictation_Error_GenericInputs */

const en_dictation_error_generic = /** @type {(inputs: Dictation_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not start dictation`)
};

const pt_br2_dictation_error_generic = /** @type {(inputs: Dictation_Error_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível iniciar o ditado`)
};

/**
* | output |
* | --- |
* | "Could not start dictation" |
*
* @param {Dictation_Error_GenericInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dictation_error_generic = /** @type {((inputs?: Dictation_Error_GenericInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dictation_Error_GenericInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dictation_error_generic(inputs)
	return pt_br2_dictation_error_generic(inputs)
});